export default "__VITE_ASSET__50d45b82__"